const state = {
  searchKeyword: ''
};

const mutations = {
  setSearchKeyword(state, keyword) {
    state.searchKeyword = keyword;
  }
};

const getters = {
  // 필요시 getters 추가
};

const actions = {
  // 필요시 actions 추가
};

export default {
  namespaced: true, // 네임스페이스 활성화
  state,
  mutations,
  getters,
  actions
};
